import { useNavigate } from "react-router-dom";
import { Body, Inputs, NovoCriativoContainer } from "./styles";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../providers/Auth/index";
import { ReactSVG } from "react-svg";
import voltar from "../../../../assets/voltar.svg";
import api from "../../../../services/api";
import { CriativoObrigatorio } from "../../../../schemas/campanha";

const NovoCriativo = () => {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    resolver: yupResolver(CriativoObrigatorio),
  });

  const { user } = useAuth()
  const [files, setFiles] = useState([])
  const navigate = useNavigate();

  const onSubmitFunction = (data) => {
    api.post("/criativo", { criativos: [data] }).then((response) => {
      const criativoId = response.data.data.insertId
      api.post("/criativo-mensagem?novo=true", { criativoMensagens: [{ ...data, criativo_id: criativoId }] })
        .then((responseMensagem) => {
          if (files) {
            const formData = new FormData();
            files.forEach((arquivo, index) => {
              formData.append(`arquivo_campanha_${responseMensagem.data.data.insertId}`, arquivo);
            });

            try {
              api.post(`/criatio-mensagem-anexo/${responseMensagem.data.data.insertId}/`, formData);
              setFiles([])
              navigate(`/criativo/editar/${criativoId}`)
            } catch {
              toast.error("Erro ao enviar o arquivo, por favor tente novamente");
            }
          }
        }).catch((error) => {
          console.log(error)
          toast.error("Erro na criação"
          )
        })
      toast.success("Criativo cadastrado com sucesso!");
    })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  function removerArquivo(index) {
    const novaListaArquivos = [...files];
    novaListaArquivos.splice(index, 1);
    setFiles(novaListaArquivos);
  }

  useEffect(() => {
  }, []);

  return (
    <NovoCriativoContainer onSubmit={handleSubmit(onSubmitFunction)}>
      <div className="box">
        <div className="flex">
          <ReactSVG
            onClick={() => navigate("/criativo")}
            className="voltar"
            src={voltar}
          />
          <h1>Criativo</h1>
        </div>

        <Body>
          <Inputs>
            <div>
              <label>Título *</label>
              <input
                type="text"
                name="titulo"
                {...register("titulo")}
                placeholder="Título do criativo"
              />
              {errors.titulo && (
                <span className="input-error-cadastro">
                  {errors.titulo.message}
                </span>
              )}
            </div>
          </Inputs>
          <Inputs>
            <div>
              <label>Tipo *</label>
              <select {...register("tipo")}>
                {user && user.perfil.includes("administrador") ?
                  <>
                    <option>Alinhamento de Necessidade</option>
                    <option>Debriefing</option>
                    <option>Entrega de V1</option>
                    <option>Entrega de V2</option>
                    <option>Entrega de V3</option>
                    <option>Entrega de V4</option>
                    <option>Entrega de V5</option>
                    <option>Entrega de V6</option>
                    <option>Briefing</option>
                    <option>Pedido de Alteração</option>
                    <option>Refação</option>
                    <option>Aprovação</option>
                  </>
                  :
                  user && ["atendimento", "produtor", "compras"].includes(user?.perfil) ?
                    <>
                      <option>Alinhamento de Necessidade</option>
                      <option>Debriefing</option>
                      <option>Entrega de V1</option>
                      <option>Entrega de V2</option>
                      <option>Entrega de V3</option>
                      <option>Entrega de V4</option>
                      <option>Entrega de V5</option>
                      <option>Entrega de V6</option>
                    </>
                    :
                    <>
                      <option>Alinhamento de Necessidade</option>
                      <option>Briefing</option>
                      <option>Pedido de Alteração</option>
                      <option>Refação</option>
                      <option>Aprovação</option>
                    </>
                }
              </select>
              {errors.tipo && (
                <span className="input-error-cadastro">
                  {errors.tipo.message}
                </span>
              )}
            </div>
          </Inputs>
          <Inputs>
            <div>
              <label>Comentário *</label>
              <textarea
                type="text"
                name="comentario"
                {...register("comentario")}
                placeholder="Título do criativo"
              />
              {errors.comentario && (
                <span className="input-error-cadastro">
                  {errors.comentario.message}
                </span>
              )}
            </div>
          </Inputs>
          <Inputs>
            <div className="column">
              <div>
                <label className="label">Anexos</label>
                <input
                  {...register("file")}
                  type="file"
                  id="file"
                  multiple={true}
                  accept="image/*, application/pdf,text/plain"
                  onChange={(e) => {
                    setFiles([...e.target.files, ...files]);
                  }}
                  hidden={true}
                />
                <label className='label-file' for="file">Anexar arquivo
                </label>
              </div>
              <div className="div-files">
                {files.length > 0 &&
                  files.map((elem, outerIndex) => (
                    <div className="relative-file" key={outerIndex}>
                      <div>
                        {elem.type.startsWith("image/") ? (
                          <img src={URL.createObjectURL(elem)} alt="Arquivo Anexado" width={100} />
                        ) : (
                          <h5>{elem.name.slice(0, 30)}{elem.name.length > 30 ? "..." : ""}</h5>
                        )}
                        <span onClick={() => removerArquivo(outerIndex)}>X</span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </Inputs>
        </Body>
        <button type="submit">Adicionar</button>
      </div>
    </NovoCriativoContainer >
  );
};

export default NovoCriativo;
